

import LayoutMain from '@/layout';
import setting from '@/setting';
let routePre = setting.routePre;

const meta = {
  auth: true,
};

const pre = 'client_';

export default {
  path: routePre + '/client',
  name: 'client',
  header: 'client',
  redirect: {
    name: `${pre}index`,
  },
  component: LayoutMain,
  children: [
	
	{
	  path: 'index',
	  name: `${pre}index`,
	  meta: {
	    auth: ['client-index'],
	    title: '我的线索',
	  },
	  component: () => import('@/pages/client/index'),
	},
	
	{
	  path: 'edit',
	  name: `${pre}edit`,
	  meta: {
	    //auth: ['client-edit'],
	    title: '修改线索',
		activeMenu: routePre + '/client/index',
	  },
	  component: () => import('@/pages/client/edit'),
	},
	
  ],
};
